import CompanyBase from '../../company_base';
import GameStepInstanceDescriptor from '../../../game/game_sequence_builder/GameStepInstanceDescriptor';
import BuildNavigationBarGameStep from '../../../game/game_steps/launch_game/open_in_game_window/build_navigation_bar_gamestep';
import BuildExternalGameProviderCssClassNameGameStep from '../../../game/game_steps/launch_game/open_in_game_window/build_external_game_provider_css_classname_gamestep';
import BuildGameBodyGameStep from '../../../game/game_steps/launch_game/open_in_game_window/build_game_body_gamestep';
import BuildGameWindowGameStep from '../../../game/game_steps/launch_game/open_in_game_window/build_game_window_gamestep';
import OpenInGameWindowGameStep from '../../../game/game_steps/launch_game/open_in_game_window/open_in_game_window_gamestep';
import GnwpGameUrlBuilderSelectionGameStep from '../gnwp_game_url_builder_selection_gamestep';
import Device from '../../../../utils/device/device';
import NyxGamePostMessageListener from './post_message/nyx_game_post_message_listener';
import OpenInRedirectGameStep from "../../../game/game_steps/launch_game/open_in_redirect_gamestep";

const COMPANY_NAME = 'nyx';

export default class NyxCompany extends CompanyBase {
    static CLASS = 'NyxCompany';

    static canHandle(companyName) {
        return companyName.toLowerCase() === COMPANY_NAME;
    }

    getRealGameSequenceBuilder(gameOptions, gameSequenceBuilder) {
        let builder = super.getRealGameSequenceBuilder(gameOptions, gameSequenceBuilder);

        if(Device.hybrid.isEmbedded && !this.serviceFactory.gamesInformationService().isLiveGamesGroup(gameOptions.gameInfo.gameGroupId)) {
            gameOptions.NyxLinkID = 50;
        } else {
            gameOptions.NyxLinkID = null;
        }

        let getGameUrlCallback = (gOptions) => gOptions.gameUrlBuilder.buildRealGameUrl(gOptions);

        return this._getGameSequenceBuilder(builder, true, getGameUrlCallback, gameOptions);

    }

    getAnonymousGameSequenceBuilder(gameOptions, gameSequenceBuilder) {
        let builder = super.getAnonymousGameSequenceBuilder(gameOptions, gameSequenceBuilder);

        let getGameUrlCallback = (gOptions) => gOptions.gameUrlBuilder.buildAnonymousGameUrl(gOptions);

        return this._getGameSequenceBuilder(builder, false, getGameUrlCallback, gameOptions);
    }

    _getGameSequenceBuilder(gameSequenceBuilder, isReal, getGameUrlCallback, gameOptions) {
        gameSequenceBuilder = gameSequenceBuilder.insert(this._getGnwpGameUrlBuilderSelectionGameStepDescriptor()).last();

        if((Device.hybrid.isEmbedded && !this.serviceFactory.gamesInformationService().isLiveGamesGroup(gameOptions.gameInfo.gameGroupId)) || gameOptions.forceOpenGameInRedirect) {
            gameSequenceBuilder = gameSequenceBuilder.insert(OpenInRedirectGameStep, {getGameUrlCallback: getGameUrlCallback}).last();
        } else {
            gameSequenceBuilder = this.getOpenGameInWindowSequence(gameSequenceBuilder, isReal, getGameUrlCallback);
        }

        return gameSequenceBuilder;
    }

    getHistoryGameSequenceBuilder(gameOptions, gameSequenceBuilder) {
        let getGameUrlCallback = (gOptions) => gOptions.gameUrlBuilder.buildHistoryGameUrl(gOptions);

        return super.getHistoryGameSequenceBuilder(gameOptions, gameSequenceBuilder)
                           .insert(this._getGnwpGameUrlBuilderSelectionGameStepDescriptor()).last()
                           .insert(BuildExternalGameProviderCssClassNameGameStep, {providerName: COMPANY_NAME}).last()
                           .insert(BuildGameBodyGameStep, {getGameUrlCallback: getGameUrlCallback, allowScrolling: true}).last();
    }

    _getAdditionalParametersCallback(gameOptions) {
        if (gameOptions.NyxLinkID) {
            return {
                NyxLinkID: gameOptions.NyxLinkID
            };
        } else {
            return {};
        }
    }

    _getGnwpGameUrlBuilderSelectionGameStepDescriptor() {
        return GameStepInstanceDescriptor.create({
            stepPrototype: GnwpGameUrlBuilderSelectionGameStep,
            stepParams: {
                templateName: 'NYX',
                getAdditionalParametersCallback: this._getAdditionalParametersCallback
            }
        });
    }

    getOpenGameInWindowSequence(builder, isReal, getGameUrlCallback){
        return builder.insert(BuildNavigationBarGameStep, {isReal: isReal}).last()
            .insert(BuildExternalGameProviderCssClassNameGameStep, {providerName: COMPANY_NAME}).last()
            .insert(BuildGameBodyGameStep, {getGameUrlCallback: getGameUrlCallback}).last()
            .insert(BuildGameWindowGameStep, {isReal: isReal}).last()
            .insert(OpenInGameWindowGameStep).last();
    }

    getGamePostMessageListener(gameOptions) {
        return Promise.resolve(NyxGamePostMessageListener.create({
            serviceFactory: this.serviceFactory,
            gameOptions: gameOptions
        }));
    }

}
